import pize_mobi from "../../assets/images/Introduction/pize_mobi.webp";
import pize_pc from "../../assets/images/Introduction/pize_pc.webp";
import cip1_pc from "../../assets/images/Introduction/cip1_pc.webp";
import cip_mobi from "../../assets/images/Introduction/cip_mobi.webp";
import gtdt from "../../assets/images/Introduction/gtdt.webp";
import gtpc from "../../assets/images/Introduction/gtpc.webp";
export default function Prize() {
  return (
    <div
      className="w-full bg-center bg-cover bg-no-repeat "
      style={{
        backgroundImage: `url(${
          window.innerWidth < 768 ? pize_mobi : pize_pc
        })`,
      }}
    >
      <div className="w-full container mx-auto px-[20px] py-[50px] flex flex-col gap-5 ">
        <div className="w-full flex flex-col gap-2">
          <div className="w-full flex items-center justify-center ">
            <p className="md:text-[32px] text-[23px] font-semibold text-[#053CC8]">
              GIẢI THƯỞNG ĐÁNG TỰ HÀO
            </p>
          </div>

          <div>
            <p className="text-[18px] text-[#606060] font-normal text-center">
              Chúng tôi tự hào nhận được những giải thưởng của nhà nước chứng
              nhận sản phẩm tiêu biểu của năm
            </p>
          </div>
        </div>
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-3 items-center md:-mt-16 ">
          <div className="flex items-center justify-center">
            <img
              src={cip_mobi}
              alt="cip"
              className="w-full h-auto object-cover block md:hidden"
            />
            <img
              src={cip1_pc}
              alt="cip1"
              className="w-full h-auto object-cover hidden md:block"
            />
          </div>
          <div className="flex items-center justify-center">
            <img
              src={gtdt}
              alt="gt"
              className="w-full h-auto object-cover block md:hidden"
            />
            <img
              src={gtpc}
              alt="gt4"
              className="w-full h-auto object-cover hidden md:block"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
